import { Injectable } from '@angular/core';
import { UseCase } from '../../base';
import {
  GetSegmentSuggestionsRequest,
  SegmentSuggestions,
} from '../../domain/models';
import { LocationsRepository } from '../../repositories';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class GetSegmentSuggestionsUsecase
  implements
    UseCase<GetSegmentSuggestionsRequest, SegmentSuggestions[]>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(
    params: GetSegmentSuggestionsRequest
  ): Observable<SegmentSuggestions[]> {
    return this.locationRepository.getSegmentSuggestions(params);
  }
}
